import { Component } from '@angular/core';
import { IonicPage, ToastController, PopoverController, Popover, LoadingController, ActionSheetController } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { APIOnLine } from '../../services/api/api.services';
import { PaginaBasica } from '../../models/PaginaBase';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { Proxy } from '../../services/proxy/proxy.service';

@IonicPage()
@Component({
  selector: 'page-tiempo-muerto',
  templateUrl: 'tiempo-muerto.html',
})
export class TiempoMuertoPage extends PaginaBasica {

  //#region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public datosFutbolSala: Proxy.PrFutbolSala;
  //#endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA: QUINTETO ---');

    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.MostrarOcultarCarga(false, "cargando información");

    this.datosFutbolSala = new Proxy.PrFutbolSala(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);

    this.datosFutbolSala.Cargar()
      .then((resultado: Proxy.PrFutbolSala) => {
        this.datosFutbolSala = resultado;
        this.MostrarOcultarCarga();
      })
      .catch(error => this.Error(error, "ERROR al obtener los alineados del equipo actual"));
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event
    });
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/tiempo-muerto/tiempo-muerto.ts